module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuMzY5NjI5IDIwLjYxMDJMMTIuMzY5NiAwLjAxMjQ1MTJMMjQuNDYxNiAyMC42MTAyTDIxLjAxMzMgMjQuMDEyNUwxNC4yNTQ3IDE5LjA0NjlIMTguNjY4NUwxMi4zNjk2IDguNzQ4MDhMNi4xMTY3NiAxOS4wNDY5SDEwLjU3NjVMMy43NzE5MyAyNC4wMTI1TDAuMzY5NjI5IDIwLjYxMDJaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/games/games_white/apex.svg
// module id = G0TI
// module chunks = 35